export default {
  projects: (state) => state.projects,
  projectDetails: (state) => state.projectDetails,
  filterParameters: (state) => state.filterParameters,
  scrollPosition: (state) => state.scrollPosition,
};
